import '@babel/runtime/regenerator'
import Vue from 'vue'
import VueHtml2Canvas from 'vue-html2canvas'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import components from './components'
import utils from './utils'
import './styles/main.scss'
import './styles/pickerPanel.scss'
import { formatDecimal, isInt, stepPrice } from '@/utils/stepPrice'
import {
	sanitizeHtml,
	sanitizeHtmlStrict,
	sanitizeText,
} from '@/utils/sanitize'
import {
	handleChunkLoadError,
	cleanupChunkErrorModal,
} from '@/utils/chunkErrorHandler'
import 'vue-scroll-picker/dist/style.css'

Vue.config.productionTip = false

// Vue 全域錯誤處理器
Vue.config.errorHandler = (error, vm, info) => {
	console.error('Vue 全域錯誤:', error, info)
	if (handleChunkLoadError(error)) {
		return
	}
}

// 全域 unhandledrejection 事件監聽器（處理 Promise 拒絕）
window.addEventListener('unhandledrejection', event => {
	console.error('未處理的 Promise 拒絕:', event.reason)
	if (handleChunkLoadError(event.reason)) {
		event.preventDefault()
	}
})

// 全域 error 事件監聽器
window.addEventListener('error', event => {
	console.error('全域錯誤事件:', event.error)
	if (handleChunkLoadError(event.error)) {
		event.preventDefault()
	}
})
Vue.prototype.$stepPrice = stepPrice
Vue.prototype.$isInt = isInt
Vue.prototype.$formatDecimal = formatDecimal
Vue.prototype.$sanitizeHtml = sanitizeHtml
Vue.prototype.$sanitizeHtmlStrict = sanitizeHtmlStrict
Vue.prototype.$sanitizeText = sanitizeText
Vue.prototype.$env = process.env
Vue.use(components)
Vue.use(utils)
Vue.use(VueHtml2Canvas)

window.$devLog = (...args) => {
	if (process.env.NODE_ENV === 'development') {
		const log = console[args[0]]
		if (log) {
			log(...args.slice(1))
		} else {
			console.log(...args)
		}
	}
}

window.$jsonLog = (...args) => {
	if (process.env.NODE_ENV === 'development') {
		const formattedArgs = args.map(arg =>
			typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg,
		)

		const log = console[formattedArgs[0]]
		if (log) {
			log(...formattedArgs.slice(1))
		} else {
			console.log(...formattedArgs)
		}
	}
}

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount('#app')

// 頁面卸載時清理彈窗實例，防止記憶體洩漏
window.addEventListener('beforeunload', () => {
	cleanupChunkErrorModal()
})
